import { ColumnAccessorSortable } from '@/types/columns';
import { atom } from 'jotai';

export const DEFAULT_COLUMN_ORDER: ColumnAccessorSortable[] = [
  ColumnAccessorSortable.isBestSeller,
  ColumnAccessorSortable.stockQuantity,
  ColumnAccessorSortable.gtin,
  ColumnAccessorSortable.sku,
  ColumnAccessorSortable.shopifyVariantId,
  ColumnAccessorSortable.listPrice,
  ColumnAccessorSortable.discountedPrice,
  ColumnAccessorSortable.chooseDiscount,
  ColumnAccessorSortable.choosePrice,
  ColumnAccessorSortable.buyingPrice,
  ColumnAccessorSortable.marginPercentage,
  ColumnAccessorSortable.couponExpirationDate,
  ColumnAccessorSortable.couponTerms,
  ColumnAccessorSortable.couponHowToUse,
  ColumnAccessorSortable.potentialSalesVolume,
  ColumnAccessorSortable.madeIn,
  ColumnAccessorSortable.shippingPrice,
  ColumnAccessorSortable.productType,
  ColumnAccessorSortable.vatRate,
  ColumnAccessorSortable.description,
  ColumnAccessorSortable.sourceUrl,
  ColumnAccessorSortable.eeePrice,
];

export const columnOrderState = atom<ColumnAccessorSortable[]>([
  ...DEFAULT_COLUMN_ORDER,
]);
